import { createSelector } from "reselect";

export const mediaVideoStateSelector = state => state.stickers.mediaVideo;

export const isMediaStreamFailed = createSelector(
  mediaVideoStateSelector,
  (state) => state.isMediaStreamFailed
);